import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import DashboardLayout from './DashboardLayout';
import FeatureAccessGuard from './FeatureAccessGuard';
import StorageService from '../../services/storage/storageService.js';
import { getProfileRole } from '../../utils/profileRoles.js';
import { useFeatureFlags } from '../../contexts/FeatureFlagsContext.jsx';
import {
  getEconomistRequiredFeaturesForPath,
  isEconomistPathAllowed,
} from '../../utils/economistAccess.js';

const PrivateRoute = ({
  children,
  userToken,
  onLogout,
  noLayout = false,
  featureCode = null,
  featureCodes = null,
  allowedRoles = null,
}) => {
  const location = useLocation();
  const { role: capabilityRole } = useFeatureFlags();
  // Check if user is authenticated
  if (!userToken) {
    return <Navigate to="/login" replace />;
  }

  const profile = StorageService.get('userData');
  if (!profile && location.pathname !== '/main') {
    return <Navigate to="/main" replace />;
  }
  const userRole = capabilityRole || getProfileRole(profile);
  if (Array.isArray(allowedRoles) && !allowedRoles.includes(userRole)) {
    return <Navigate to="/main" replace />;
  }
  if (userRole === 'economist' && !isEconomistPathAllowed(location.pathname)) {
    return <Navigate to="/main" replace />;
  }

  const requestedFeatures = featureCodes || (featureCode ? [featureCode] : []);
  const economistFeatures = userRole === 'economist'
    ? getEconomistRequiredFeaturesForPath(location.pathname)
    : [];
  const requiredFeatures = [...new Set([...requestedFeatures, ...economistFeatures])];

  const guardedChildren = requiredFeatures.length ? (
    <FeatureAccessGuard featureCodes={requiredFeatures}>
      {children}
    </FeatureAccessGuard>
  ) : children;

  // Some pages might not need the layout (like full-screen pages)
  if (noLayout) {
    return guardedChildren;
  }

  // Wrap the children with DashboardLayout
  return (
    <DashboardLayout onLogout={onLogout}>
      {guardedChildren}
    </DashboardLayout>
  );
};

export default PrivateRoute;
